import { keyBy, map, merge, pick } from "lodash";

class AgGridUtility {
  static defaultMenuItems = [
    "cut",
    "copy",
    "copyWithHeaders",
    "copyWithGroupHeaders",
    "paste",
  ];

  static menuItemsWithExport = [
    ...AgGridUtility.defaultMenuItems,
    "separator",
    "export",
  ];

  static onServerSideRowCreated(gridApi, row) {
    if (!gridApi) return;

    if (gridApi.getDisplayedRowCount() < gridApi.paginationGetPageSize()) {
      gridApi.applyServerSideTransaction({ add: [row] });
      return;
    }

    gridApi.setRowCount(gridApi.getModel().getRowCount() + 1);
  }

  static onServerSideRowsUpdated(gridApi, rows) {
    if (!gridApi) return;

    gridApi.applyServerSideTransaction({ update: rows });

    gridApi.refreshCells({ force: true });
  }

  static onServerSideRowDeleted(gridApi, id) {
    if (!gridApi) return;

    gridApi.applyServerSideTransaction({
      remove: [{ id }],
    });
  }

  static getFilteredSelectedRows(gridApi, allAvailableIds) {
    const { selectAll, toggledNodes } = gridApi.getServerSideSelectionState();
    const toggled = toggledNodes.map(Number);

    const filterValues = gridApi.getFilterModel()?.isManual?.values || [];
    const isFilterApplied = filterValues.length > 0;
    const isManual = filterValues[0] === "1";

    if (!selectAll || !isFilterApplied) {
      return toggled;
    }

    const available = isManual ? allAvailableIds.manual : allAvailableIds.auto;
    return available.filter((id) => !toggled.includes(id));
  }

  static prepareColumnStateToSave(defaultColDefs, actualColDefs) {
    const columnDefMap = keyBy(defaultColDefs, "field");

    return actualColDefs.map((el) => {
      const merged = { ...(columnDefMap[el.colId] || {}), ...el };

      return pick(merged, [
        "pinned",
        "width",
        "headerName",
        "hide",
        "field",
        "sortable",
        "tooltipField",
        "suppressMovable",
        "sort",
      ]);
    });
  }

  static mergeSavedColumnState = (defaultColDefs, actualColDefs) => {
    const lookup = keyBy(defaultColDefs, "field");

    return map(actualColDefs, (item) => {
      const defaultColDef = lookup[item.field] || {};
      const merged = merge({}, defaultColDef, item);

      if (defaultColDef.lockVisible) {
        merged.hide = defaultColDef.hide;
      }

      return merged;
    });
  };
}

export default AgGridUtility;
